import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Alert, Button, Descriptions, Empty, Icon, message, Popconfirm, Spin } from 'antd';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import ContentWrapper from '../content_wrapper/ContentWrapper';
import { CONTACTS_RESOURCE_NAME } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import { ApiError } from '../../utils/errors';
import { makeMsisdnBeautiful } from '../../Utils';
import TEXTS from "../../locale/texts";

class ContactDetail extends Component {
  state = {
    isBlacklistLoading: false,
    isDeleteLoading: false,

    // one of contacts resource
    oneOfContactsData: null,
    oneOfContactsDataIsLoading: true,
    oneOfContactsDataError: null,

    blacklistContactsIsLoading: false,
    blacklistContactsError: null,

    deleteOneOfContactsIsLoading: false,
    deleteOneOfContactsError: null
  };

  callResource = _callResource.bind(this);

  toAllContacts = () => {
    this.props.history.push('/phonebook/contacts');
  };

  onDelete = async () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { id } = this.state.oneOfContactsData;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'deleteOneOf',
      apiCallParams: { id },
      promiseCancelToken,
      onSuccess: () => {
        addNotification(TEXTS.contactIsDeleted[lang]);
        this.toAllContacts();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.couldNotDeleteContact[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  onEdit = () => {
    const { slug, history } = this.props;
    history.push({
      pathname: `/phonebook/contacts/edit/${slug}`,
      state: { ...this.state.oneOfContactsData }
    });
  };

  onBlackList = async () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { id, inBlackList } = this.state.oneOfContactsData;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'blacklist',
      apiCallParams: { ids: [id], addOrRemove: inBlackList ? 'remove' : 'add' },
      promiseCancelToken,
      onSuccess: () => {
        const msg = inBlackList
          ? TEXTS.contactIsRemovedFromBlackList[lang]
          : TEXTS.contactIsAddedToBlackList[lang];
        addNotification(msg);
        this.getContactData();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        const msg = inBlackList
          ? TEXTS.couldNotRemoveOneContactFromBlackList[lang]
          : TEXTS.couldNotAddOneContactToBlackList[lang];
        message.error(`${msg}: ${errorMessage}.`, 5);
      }
    });
  };

  getContactData = () => {
    const { slug, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'getOneOf',
      apiCallParams: { id: slug.split('_')[1] },
      promiseCancelToken
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getContactData();
  }

  renderData = () => {
    const { lang } = this.props;
    const {
      oneOfContactsData,
      oneOfContactsDataError,
      blacklistContactsIsLoading,
      deleteOneOfContactsIsLoading
    } = this.state;

    const colSpan = 2;

    if (oneOfContactsDataError) {
      const { errorTitle, errorMessage } = oneOfContactsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const {
      msisdn,
      groups,
      firstname,
      middlename,
      lastname,
      city,
      email,
      birthDate,
      inBlackList,
      wishBirthday,
      note,
    } = oneOfContactsData;

    return (
      <>
        <div style={{position: 'relative'}}>
          <h4
            className="form-row title text-pink text-uppercase mb-4"
            style={{
              display: 'inline-block',
              marginRight: 10
            }}
          >
            {makeMsisdnBeautiful(msisdn)}
          </h4>
          <Button
            type="primary"
            ghost
            icon="edit"
            shape="circle"
            title={TEXTS.btnEdit[lang]}
            style={{position: 'relative', top: -2, marginRight: 5}}
            onClick={this.onEdit}
          />
          <Popconfirm
            placement="right"
            title={TEXTS.areYouSureToDeleteContact[lang]}
            okText={TEXTS.yes[lang]}
            cancelText={TEXTS.btnToCancel[lang]}
            onConfirm={this.onDelete}
          >
            <Button
              type="danger"
              ghost={!deleteOneOfContactsIsLoading}
              icon="delete"
              shape="circle"
              title={TEXTS.btnDelete[lang]}
              loading={deleteOneOfContactsIsLoading}
              style={{position: 'relative', top: -2}}
            />
          </Popconfirm>
          {inBlackList &&
            <p style={{position: 'absolute', top: 3, right: 0, marginLeft: 10, fontSize: 12}}>
              {TEXTS.contactIsInBlackList[lang]}
              <Icon
                type="stop"
                style={{position: 'relative', top: -2, marginLeft: 5, fontSize: 24}}
                title={TEXTS.contactIsInBlackList[lang]}
                theme="twoTone" twoToneColor="#ff4d4f"
              />
             </p>}
        </div>
        <div className='form-row mb-4'>
          <Button
            disabled={blacklistContactsIsLoading}
            style={{padding: '0 20px 0 20px', height: 45, marginLeft: 0}}
            onClick={this.onBlackList}
          >
            {blacklistContactsIsLoading && <Icon type="loading" style={{fontSize: 20}} />}
            {!inBlackList ? TEXTS.btnBlackListAdd[lang] : TEXTS.btnBlackListRemove[lang]}
          </Button>
          <Popconfirm
            placement="right"
            title={TEXTS.areYouSureToDeleteContact[lang]}
            okText={TEXTS.yes[lang]}
            cancelText={TEXTS.btnToCancel[lang]}
            onConfirm={this.onDelete}
          >
          </Popconfirm>
        </div>
        <Descriptions
          column={{
            xxl: 2,
            xl: 2,
            lg: 2,
            md: 2,
            sm: 1,
            xs: 1
          }}
          size="middle"
          bordered
        >
          <Descriptions.Item label={TEXTS.contactPhoneLabel[lang]} span={colSpan}>
            {makeMsisdnBeautiful(msisdn)}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.tabNameGroups[lang]} span={colSpan}>
            {groups || '—'}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.isInBlackList[lang]} span={colSpan}>
            {inBlackList ? TEXTS.yes[lang] : TEXTS.no[lang]}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.contactNameLabel[lang]} span={colSpan}>
            {firstname || '—'}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.contactSecondNameLabel[lang]} span={colSpan}>
            {middlename || '—'}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.contactMiddleNameLabel[lang]} span={colSpan}>
            {lastname || '—'}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.contactCityLabel[lang]} span={colSpan}>
            {city || '—'}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.contactEmailLabel[lang]} span={colSpan}>
            {email || '—'}
          </Descriptions.Item>
          <Descriptions.Item label={TEXTS.birthDate[lang]} span={colSpan}>
            {birthDate || '—'}
          </Descriptions.Item>
          {/*<Descriptions.Item label="Поздравить с днем рождения" span={colSpan}>*/}
            {/*{wishBirthday ? 'Да' : 'Нет'}*/}
          {/*</Descriptions.Item>*/}
          <Descriptions.Item label={TEXTS.comment[lang]} span={colSpan}>
            {note || '—'}
          </Descriptions.Item>
        </Descriptions>
      </>
    );
  };

  render() {
    const { lang } = this.props;
    if (this.state.oneOfContactsDataIsLoading) {
      return(
        <div>
          <ContentWrapper>
            <Empty description={TEXTS.dataIsLoading[lang]} />
            <div style={{marginTop: 15, textAlign: 'center'}}>
              <Spin spinning={true} />
            </div>
          </ContentWrapper>
        </div>
      );
    }

    return (
      <ContentWrapper>
        {this.renderData()}
      </ContentWrapper>
    );
  }
}

export default (withRouter(ContactDetail));
